import { useMemo } from 'react'
import { contentMap } from 'utils/contentful'

export const useMemoizedContentGetter = (content, fieldNames) => {
  return useMemo(
    () => contentMap(content?.fields?.sectionContents || [], fieldNames),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [content, ...fieldNames]
  )
}

export const useInlineMemoizedContentGetter = (content, fieldNames) => {
  return useMemo(
    () => contentMap(content || [], fieldNames),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [content, ...fieldNames]
  )
}
